import ReactDOM from 'react-dom/client';
import App from './App';

import { BrowserRouter } from 'react-router-dom';

import { ColorModeScript } from '@chakra-ui/react';
import { theme } from './styles/theme';
import { AuthContextProvider } from './contexts/AuthContext';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/services/api/queryClient';
import { AdminConfigService } from '@/services/instances/admin-config';
import DynamicThemeProvider from './contexts/ThemeContext/DynamicThemeProvider';

import './i18n';

AdminConfigService.setConfig();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <ColorModeScript initialColorMode={theme().config.initialColorMode} />
    <QueryClientProvider client={queryClient}>
      <AuthContextProvider>
        <BrowserRouter>
          <DynamicThemeProvider>
            <App />
          </DynamicThemeProvider>
        </BrowserRouter>
      </AuthContextProvider>
    </QueryClientProvider>
  </>,
);
